module.exports = __webpack_public_path__ + "static/media/gives-back.54e3a6f5.png";